var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95455 12C5.95455 10.4939 4.73349 9.27275 3.22727 9.27275C1.72105 9.27275 0.5 10.4939 0.5 12C0.5 13.5061 1.72105 14.7273 3.22727 14.7273C4.73349 14.7273 5.95455 13.5061 5.95455 12Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4787 9.27275C13.9849 9.27275 15.206 10.4939 15.206 12C15.206 13.5061 13.9849 14.7273 12.4787 14.7273C10.9725 14.7273 9.75142 13.5061 9.75142 12C9.75142 10.4939 10.9725 9.27275 12.4787 9.27275Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7727 9.27275C23.2789 9.27275 24.5 10.4939 24.5 12C24.5 13.5061 23.2789 14.7273 21.7727 14.7273C20.2665 14.7273 19.0455 13.5061 19.0455 12C19.0455 10.4939 20.2665 9.27275 21.7727 9.27275Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/actions.6d7fafd11c690dff39d187d9ffb3e852.svg";
export { ForwardRef as ReactComponent };